import { IOrganization } from "./IOrganization"

// This class is only used for users with a Learner role but no corresponding Organization record.
// See IlpContext.checkForRolesWithNoOrg() 
// OrgyTypeCode is populated forease of filtering, if needed. Key is populated for dropdown onChange handlers.
export class Organization implements IOrganization{
    public AapId : number;
    public Name : string | null;
    public Title : string | null;
    public OrgTypeCode : string | null;
    public SubTypeCode : string | null;
    public RelationshipTypeCode : string | null;
    public StartDate : string | null;
    public EndDate : string | null;
    public OrganizationKey : string | null;
  
    constructor(name: string, title: string) {
      this.AapId = 0;
      this.Name = name;
      this.Title = title;
      this.OrgTypeCode = "StandAlone";
      this.SubTypeCode = null;
      this.RelationshipTypeCode = null;
      this.StartDate = null;
      this.EndDate = null;
      this.OrganizationKey = "StandAlone";
    }
}